import { readCheckedValue } from '../../field-viewer/prehydration-readers';
import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const quizRadioGroupViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel,
    readPrehydrationValue: readCheckedValue
};

//# sourceMappingURL=definition-viewer.js.map